import {
  createUnitTypeOptions,
  WORKING_DECLARATION_LABEL_KEYS,
} from '@/config/unitTypes.constants';

// A contract carries the same quantity in two units — see contracts/CLAUDE.md.
export const { unitTypeLabel, buildRowUnitOptions, buildUnitHeaderOptions } = createUnitTypeOptions(
  WORKING_DECLARATION_LABEL_KEYS,
);
